import * as React from 'react';

export interface IrrevocableTrustIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * IrrevocableTrustIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Irrevocable trust. Trust document with closed padlock — both shackle legs seated, indicating the trust is locked and cannot be unilaterally modified.
 */
const IrrevocableTrustIcon: React.FunctionComponent<IrrevocableTrustIconProps> = ({
  className,
  size = 40,
  title = 'Irrevocable Trust',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M10 4 Q10 3 11 3 L32 3 L40 11 L40 43 Q40 44 39 44 L11 44 Q10 44 10 43 Z" fill="#FFFFFF" stroke="#3C3489" strokeWidth="1.4"/>
      <path d="M32 3 L32 11 L40 11 Z" fill="#3C3489"/>
      <text x="22" y="12" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="4" fontWeight="700" fill="#3C3489" letterSpacing="0.5">TRUST</text>
      <line x1="14" y1="16" x2="36" y2="16" stroke="#3C3489" strokeWidth="0.8"/>
      <line x1="14" y1="19" x2="32" y2="19" stroke="#3C3489" strokeWidth="0.8"/>
      <line x1="14" y1="22" x2="36" y2="22" stroke="#3C3489" strokeWidth="0.8"/>
      <path d="M19 28 L19 23 Q19 19 25 19 Q31 19 31 23 L31 28" stroke="#3C3489" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <rect x="16" y="28" width="18" height="13" rx="1.5" fill="#3C3489"/>
      <circle cx="25" cy="34" r="1.5" fill="#FFFFFF"/>
      <rect x="24.4" y="34" width="1.2" height="4" fill="#FFFFFF"/>
  </svg>
);

export default IrrevocableTrustIcon;
